import React, { useRef, useState } from "react";
import styled from "styled-components";
import ExtensionDealSideBar from "./ExtensionDealSideBar";
import ExtensionNewDeal from "./ExtensionNewDeal";
import ExtensionNewDealFooter from "./ExtensionNewDealFooter";
import { colors } from "app/popleads/components/ui-kit/colors";
import { useExtensionContext } from "../ExtensionContext";
import Label from "app/popleads/components/ui-kit/Label";
import { StyledNameTag } from "./ExtensionViewDeal";
import ExtensionTransferDealPage from "./ExtensionTransferDealPage";
import useDealTransfer from "app/popleads/hooks/useDealTransfer";
import { Avatar, AvatarSvg, Info, Name, ResultItem, ResultText } from "./ExtensionSearch";
import { toAbsoluteUrl } from "_metronic/_helpers";

export const NewDealContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
`;

const NewDealMenu = styled.div`
    min-width: 225px;
    height: 100%;
    border-right: 1px solid ${({ theme }) => theme.colors?.neutral?.[100] || "#E5E7EB"};
`;

export const NewDealContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow-x: hidden;
`;

export const NewDealContent = styled.div`
    width: 100%;
    height: 100%;
    padding: 24px;
    overflow-y: auto;
`;

const CompanyInfoContainer = styled.div`
    height: 131px;
    background-color: ${colors.white};
    border-top: 1px solid ${colors.neutral[100]};
    padding: 20px;
`;

const CompanyHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const CompanyIcon = styled.img`
    height: 40px;
    width: 40px;
    background-color: ${colors.neutral[100]};
    color: ${colors.neutral[700]};
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 14px;
`;

const CompanyName = styled.div`
    margin-top: 12px;
    font-size: 12px;
    font-weight: 500;
`;

const SidebarWrapper = styled.div`
    height: calc(100% - 131px);
`;

export const DealTooltip = styled.div`
    position: absolute;
    background: white;
    border: 1px solid ${colors.neutral[200]};
    border-radius: 4px;
    padding: 8px;
    width: 350px;
    height: max-content;
    max-height: 240px;
    overflow: auto;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 1000;

    bottom: 100%;
    left: 0px;
`;

export const DealLabelWrapper = styled.div`
    position: relative;
    cursor: pointer;

    &:hover ${DealTooltip} {
        display: block;
    }
`;

export const StyledResultItem = styled(ResultItem)`
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: ${colors.neutral[100]};
    }

    &:active {
        background-color: ${colors.neutral[200]};
    }
`;

const ExtensionNewDealPage = ({ wonDeals }) => {
    const formRef = useRef();
    const { profile, popupContent, wonDeals: wonDealsAccountId } = useExtensionContext();
    const [tooltipVisible, setTooltipVisible] = useState(false);

    const { transferDeal, loading: transferDealLoading } = useDealTransfer();
    const [target, setTarget] = useState(null);

    const handleTransferDeal = (dealId, targetId, profilId) => {
        transferDeal({ dealId, targetId, profilId });
    };

    const searchInputOptionClick = (id) => {
        window.open(`/extension?profileId=${id}`, "_blank");
    };
    return (
        <NewDealContainer>
            <NewDealMenu>
                <SidebarWrapper>
                    <ExtensionDealSideBar />
                </SidebarWrapper>

                <CompanyInfoContainer>
                    <CompanyHeader>
                        {wonDeals &&
                        wonDeals.profile &&
                        wonDeals.profile.length > 0 &&
                        wonDeals.profile[0].accountLogoUrl ? (
                            <CompanyIcon src={wonDeals.profile[0].accountLogoUrl} />
                        ) : (
                            <StyledNameTag>
                                {wonDeals &&
                                wonDeals.profile &&
                                wonDeals.profile.length > 0 &&
                                wonDeals.profile[0].accountName
                                    ? wonDeals.profile[0].accountName.charAt(0)
                                    : profile?.accountName?.charAt(0) || ""}
                            </StyledNameTag>
                        )}
                        {wonDeals && wonDeals.wonDealCount > 0 && (
                            <DealLabelWrapper
                                onMouseEnter={() => setTooltipVisible(true)}
                                onMouseLeave={() => setTooltipVisible(false)}
                            >
                                <Label variant="success">
                                    {wonDeals.wonDealCount + " " + (wonDeals.wonDealCount === 1 ? "Deal" : "Deals")}
                                </Label>
                                <DealTooltip
                                    onMouseEnter={() => setTooltipVisible(true)}
                                    onMouseLeave={() => setTooltipVisible(false)}
                                    style={{ display: tooltipVisible ? "block" : "none" }}
                                >
                                    {wonDealsAccountId &&
                                        wonDealsAccountId?.profiles?.length > 0 &&
                                        wonDealsAccountId.profiles.map((result, index) => (
                                            <StyledResultItem
                                                key={index}
                                                onClick={() => searchInputOptionClick(result.id)}
                                            >
                                                {result.resim ? (
                                                    <Avatar
                                                        src={result.resim}
                                                        alt={result.ad}
                                                        onError={(e) =>
                                                            (e.currentTarget.src = toAbsoluteUrl(
                                                                "/media/svg/icons/Extension/user-avatar.svg"
                                                            ))
                                                        }
                                                    />
                                                ) : (
                                                    <AvatarSvg
                                                        src={toAbsoluteUrl(
                                                            "/media/svg/icons/Extension/user-avatar.svg"
                                                        )}
                                                    />
                                                )}
                                                <ResultText>
                                                    <Name>
                                                        {result.ad} {result.soyad}
                                                    </Name>
                                                    <Info>
                                                        {result.sirket && result.sirket}
                                                        {result.sirket && result.baslik && " | "}
                                                        {result.baslik && result.baslik}
                                                    </Info>
                                                </ResultText>
                                            </StyledResultItem>
                                        ))}
                                </DealTooltip>
                            </DealLabelWrapper>
                        )}
                    </CompanyHeader>
                    <CompanyName>{profile?.accountName}</CompanyName>
                </CompanyInfoContainer>
            </NewDealMenu>
            <NewDealContentWrapper>
                <NewDealContent>
                    {popupContent === "Transfer Deal" ? (
                        <ExtensionTransferDealPage
                            target={target}
                            setTarget={setTarget}
                            transferDealLoading={transferDealLoading}
                            transferDeal={handleTransferDeal}
                        />
                    ) : (
                        <ExtensionNewDeal ref={formRef} />
                    )}
                </NewDealContent>
                <ExtensionNewDealFooter
                    target={target}
                    transferDeal={handleTransferDeal}
                    transferDealLoading={transferDealLoading}
                />
            </NewDealContentWrapper>
        </NewDealContainer>
    );
};

export default ExtensionNewDealPage;
